import {
  faArrowDown,
  faCertificate,
  faHourglassClock,
  faMessageCaptions,
  faRectangleHistoryCirclePlus,
  faSearch,
  faShieldAlt,
  faShieldCheck,
  faShieldXmark,
  faSync,
  faUsers,
} from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Chip,
  CircularProgress,
  LinearProgress,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import { post } from "../../../../_helper/api_helper";
import { ShowError, ShowSucess } from "../../../../_helper/helper";
import { advanceSearch } from "../../../../_helper/services/advanceSearchv2";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HighchartsReact from "highcharts-react-official";
import HighchartsNoDataToDisplay from "highcharts/modules/no-data-to-display";
import Highcharts from "highcharts";
import { withStyles } from "@mui/styles";
import { Btn } from "../../../../AbstractElements";
import { Icon } from "@progress/kendo-react-common";
import { loadingPanel } from "../../../../CommonComponents/CommonFunction";
import ChatUI from "./ChatUI";

HighchartsNoDataToDisplay(Highcharts);

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
    position: "relative",
    width: "100%",
  },
  colorPrimary: {
    backgroundColor: "#ffcccb", // Light color for remaining part
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#1a90ff",
  },
}))(LinearProgress);

const ProgressBar = ({ value, max }) => {
  const percentage = ((value / max) * 100).toFixed(2);
  const remainingPercentage = (100 - percentage).toFixed(2);

  return (
    <Box position="relative" display="flex" alignItems="center" width="100%">
      <BorderLinearProgress variant="determinate" value={percentage} />
      {/* <Box position="absolute" top={0} left="10px" color="#000">
        <Typography variant="body2">
          Notified: {percentage}% ({value})
        </Typography>
      </Box>
      <Box position="absolute" top={0} right="10px" color="#000">
        <Typography variant="body2">
          Remaining: {remainingPercentage}% ({max - value})
        </Typography>
      </Box> */}
    </Box>
  );
};

const ApplicantsDetail = () => {
  const location = useLocation();
  const data = location.state;

  const [searchTerm, setSearchTerm] = useState("");
  const [detailedData, setDetailedData] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [message, setMessage] = useState("");
  const [applicantsNotifyModal, setApplicantsNotifyModal] = useState(false);
  const [notifyReached, SetNotifyReached] = useState(1);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [notifyLoader, setNotifyLoader] = useState(false);
  const [sendMessage, setSendMessage] = useState("");
  const [messageModalData, setMessageModalData] = useState({});

  const isExpired = (dateString) => {
    if (!dateString) return false;
    const expiryDate = new Date(dateString);
    expiryDate.setDate(expiryDate.getDate() + 10);
    return new Date() > expiryDate;
  };

  const hasExpired = isExpired(data?.createdOn);

  //   const [oprions,setOptions] = useState(
  //     {
  //         chart: {
  //           type: "pie",
  //           backgroundColor: "transparent",
  //           height: 280,
  //           width: 310,
  //           events: {
  //             load: function () {
  //               this.update({
  //                 exporting: {
  //                   enabled: false,
  //                 },
  //               });
  //             },
  //           },
  //         },
  //         title: {
  //           text: null,
  //         },
  //         credits: {
  //           enabled: false,
  //         },
  //         plotOptions: {
  //           pie: {
  //             dataLabels: {
  //               enabled: true,
  //               format: '<b>{point.name}</b>: {point.y}',
  //               distance: -30,
  //               color: 'black'
  //             }
  //           }
  //         },
  //         series: [
  //           {
  //             innerSize: '50%',
  //             data: [
  //               { name: "Available", y: data.response, color: "lightgreen" },
  //               { name: "Unavailable", y: data.declined, color: "lightcoral" },
  //               { name: true?"Pending Response":"No Response", y: data.noAnswer, color: true?"#ffd43b":"lightgray" },
  //               { name: "Remaining", y: data.remaining, color: "lightblue" },
  //             ],
  //           },
  //         ],
  //       }
  //   )
  const [modal, setModal] = useState(false);
  const [notificationHistory, setNotificationHistory] = useState([]);
  const [auditTrailLoader, setAuditTrailLoader] = useState(false);
  const [toggleNotificationDate, setToggleNotificationDate] = useState(true);
  const sampleData = [
    {
      id: 1,
      date: "2024-07-09",
      message:
        "This is a longer message to the applicant that spans multiple lines to ensure that the table cell can handle large messages appropriately.",
      response: "Response 1",
    },
    { id: 2, date: "2023-07-07", message: "Message 2", response: "Response 2" },
    { id: 3, date: "2023-07-06", message: "Message 3", response: "Response 3" },
  ];

  const toggle = () => setModal(!modal);

  const sortedData = (sortDesec) => {
    if (sortDesec)
      return [...notificationHistory].sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      );
    else
      return [...notificationHistory].sort(
        (a, b) => new Date(a.date) - new Date(b.date)
      );
  };

  const options = {
    chart: {
      type: "pie",
      backgroundColor: "transparent",
      height: 280,
      width: 310,
      events: {
        load: function () {
          this.update({
            exporting: {
              enabled: false,
            },
          });
        },
      },
    },
    title: {
      text: null,
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>: {point.y}",
          distance: -30,
          color: "black",
        },
      },
    },
    series: [
      {
        innerSize: "50%",
        data: [
          { name: "Available", y: data?.response, color: "lightgreen" },
          { name: "Unavailable", y: data?.declined, color: "lightcoral" },
          {
            name: true ? "Pending Response" : "No Response",
            y: data.noAnswer,
            color: true ? "#ffd43b" : "lightgray",
          },
          { name: "Remaining", y: data.remaining, color: "lightblue" },
        ],
      },
    ],
  };

  //   useEffect(()=>{
  //     console.log(data,"data1221")
  //     setOptions(
  //         {
  //             chart: {
  //               type: "pie",
  //               backgroundColor: "transparent",
  //               height: 280,
  //               width: 310,
  //               events: {
  //                 load: function () {
  //                   this.update({
  //                     exporting: {
  //                       enabled: false,
  //                     },
  //                   });
  //                 },
  //               },
  //             },
  //             title: {
  //               text: null,
  //             },
  //             credits: {
  //               enabled: false,
  //             },
  //             plotOptions: {
  //               pie: {
  //                 dataLabels: {
  //                   enabled: true,
  //                   format: '<b>{point.name}</b>: {point.y}',
  //                   distance: -30,
  //                   color: 'black'
  //                 }
  //               }
  //             },
  //             series: [
  //               {
  //                 innerSize: '50%',
  //                 data: [
  //                   { name: "Available", y: data.response, color: "lightgreen" },
  //                   { name: "Unavailable", y: data.declined, color: "lightcoral" },
  //                   { name: true?"Pending Response":"No Response", y: data.noAnswer, color: true?"#ffd43b":"lightgray" },
  //                   { name: "Remaining", y: data.remaining, color: "lightblue" },
  //                 ],
  //               },
  //             ],
  //           }
  //     )
  //   },[data])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const lowercasedSearchTerm = searchTerm.toLowerCase();
      setFilteredItems(
        detailedData.filter((item) =>
          item.APPLICANT_NAME.toLowerCase().includes(lowercasedSearchTerm)
        )
      );
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [searchTerm, detailedData]);

  const getStatusIcon = (status) => {
    let pending_response = true;
    switch (status) {
      case "Accept":
        return <FontAwesomeIcon icon={faShieldCheck} />;
      case "Decline":
        return <FontAwesomeIcon icon={faShieldXmark} />;
      case "No Response":
        return <FontAwesomeIcon icon={faShieldAlt} />;
      default:
        if (pending_response)
          return <FontAwesomeIcon icon={faHourglassClock} size="sm" />;
        else return <FontAwesomeIcon icon={faShieldAlt} size="sm" />;
    }
  };

  const getStatusIconWithColor = (status, dates, count) => {
    let pending_response = true;
    if (dates.split(",").length != count) {
      status = null;
    }
    switch (status) {
      case "Accept":
        return (
          <FontAwesomeIcon
            icon={faShieldCheck}
            style={{ color: "lightgreen" }}
          />
        );
      case "Decline":
        return (
          <FontAwesomeIcon
            icon={faShieldXmark}
            style={{ color: "lightcoral" }}
          />
        );
      case "No Response":
        return (
          <FontAwesomeIcon icon={faShieldAlt} style={{ color: "lightgray" }} />
        );
      default:
        if (pending_response)
          return (
            <FontAwesomeIcon
              icon={faHourglassClock}
              style={{ color: "#ffd43b" }}
            />
          );
        else
          return (
            <FontAwesomeIcon
              icon={faShieldAlt}
              style={{ color: "lightgray" }}
            />
          );
    }
  };

  const getStatus = (status) => {
    let pending_response = true;
    switch (status) {
      case "Accept":
        return "Available";
      case "Decline":
        return "Unavailable";
      default:
        if (pending_response) return "Pending Response";
        else return "No Response";
    }
  };

  const getBackgroundForStatus = (status) => {
    let pending_response = true;
    switch (status) {
      case "Accept":
        return "lightgreen";
      case "Decline":
        return "lightcoral";
      default:
        if (pending_response) return "#ffd43b";
        else return "lightgray";
    }
  };

  const showStatusAssigned = (status) => {
    switch (status) {
      case "NS":
        return "Not Selected";
      case "SEL":
        return "Selected";
      case "REF":
        return "Selected, Not Considered";
      case "DNA":
      case "DEC":
      case "W":
      case "REJ":
        return "Not Considered";
      case "SEL,REF":
        return "Not Considered";
      default:
        return "Pending";
    }
  };

  const getStatusAssignedColor = (status) => {
    switch (status) {
      case "NS":
        return "#ff6969";
      case "SEL":
        return "#2e7d32";
      case "REF":
        return "#d32f2f";
      case "DNA":
      case "DEC":
      case "W":
      case "REJ":
        return "#d32f2f";
      case "SEL,REF":
        return "#d32f2f";
      default:
        return "#cab143";
    }
  };

  const fetchDetails = async () => {
    // setLoadingDetails(true);
    const url = `${process.env.REACT_APP_API_DOTNET_URL}/PMISAdvanceSearch/pmis-global?pageNumber=1&pageSize=100`;
    const payload = {
      tableName: "GENERAL-AVAIL",
      searchParams: `[{"columnName":"GENERAL_AVAILIBILITY_ID","value":"${data.id}","operator":"=","dataType":"varchar(MAX)","logicOperator":"AND"}]`,
      columns: "*",
      location: "pmis-global",
      pageNumber: 1,
      pageSize: 100,
      sortData: "EVALUATION_RATING desc",
      additionalWhere: "",
      qID: 0,
    };

    try {
      const response = await post(url, payload);
      setDetailedData(response?.results || []);
      return response?.results || [];
    } catch (error) {
      throw error;
    } finally {
      // setLoadingDetails(false);
    }
  };

  const createExpandData = (dataFromApi1, notificationData) => {
    console.log(dataFromApi1, notificationData, "notificationData0040");
    let dataFromApi1temp = dataFromApi1.map((item) => {
      return {
        ...item,
        no_of_notification: 1,
        notification_dates: item.Notifiedon,
      };
    });
    for (let item of dataFromApi1temp) {
      let notifyString = "";
      let notificationHistoryTemp = [];
      for (let notify of notificationData) {
        if (item?.APPLICATION_ID?.trim() == notify?.SourceId?.trim()) {
          if (notifyString) notifyString += "," + notify?.NotifiedOn;
          else notifyString += notify?.NotifiedOn;
          notificationHistoryTemp.push({
            id: notify.NotifiedOn,
            date: notify.NotifiedOn,
            message: notify?.NotificationText ?? "",
            response: notify?.ja_desc ?? "",
          });
        }
      }
      item.notificationHistory = notificationHistoryTemp;
      if (notifyString) {
        item.notification_dates = notifyString;
      }
      if (notifyString.split(",").length == 3 && item?.status == null) {
        SetNotifyReached(3);
        item.no_of_notification = 3;
      }
      if (notifyString.split(",").length == 2 && item?.status == null) {
        SetNotifyReached(2);
        item.no_of_notification = 2;
      }
    }
    return dataFromApi1temp;
  };

  const fetchNotification = async (dataFromApi1) => {
    // setLoadingDetails(true);
    // const url = `${process.env.REACT_APP_API_DOTNET_URL}/PMISAdvanceSearch/pmis-global?pageNumber=1&pageSize=100`;
    let applicationIds = dataFromApi1.map((item) =>
      item.APPLICATION_ID?.trim()
    );
    const payload = {
      tableName: "fn_Notification_by_GENERAL_AVAILIBILITY_IDnAppicationID",
      searchParams: `[{"columnName":"GENERAL_AVAILIBILITY_ID","value":"${data.id
        }","operator":"=","dataType":"varchar(MAX)","logicOperator":"AND"},{"columnName":"AppicationID","value":"${applicationIds.length == 1
          ? applicationIds[0]
          : applicationIds.join(",")
        }","operator":"=","dataType":"varchar(MAX)","logicOperator":"AND"}]`,
      columns: "*",
      location: "JobApplicant-global",
      pageNumber: 1,
      pageSize: 999,
      sortData: "",
      additionalWhere: "",
      qID: 0,
    };

    try {
      const response = await advanceSearch(payload);
      // console.log(response?.results, "fetchNotification1221");
      return createExpandData(dataFromApi1, response?.results || []);
      // setDetailedData(response?.results || []);
    } catch (error) {
      throw error;
      // ShowError(error?.message ?? "Something went wrong");
    } finally {
      // setLoadingDetails(false);
    }
  };

  const detailHandler = () => {
    setLoadingDetails(true);
    // fetchDetails();
    fetchDetails()
      .then((dataFromApi1) => fetchNotification(dataFromApi1))
      .then((dataFromApi2) => {
        console.log("Data from both APIs:", { dataFromApi2 });
        setDetailedData(dataFromApi2 || []);
      })
      .catch((error) => {
        console.error("Error in one of the API calls:", error);
        ShowError(error?.message ?? "Something went wrong");
      })
      .finally(() => {
        setLoadingDetails(false);
      });
  };

  useEffect(() => {
    detailHandler();
  }, []);

  const getAuditTrail = async (item) => {
    console.log(item, "itemdataApplicant1221");
    setAuditTrailLoader(true);
    const payload = {
      tableName: "fn_Notification_Chat",
      searchParams: `[{"columnName":"GENERAL_AVAILIBILITY_ID","value":"${item.GENERAL_AVAILIBILITY_ID?.trim()}","operator":"=","dataType":"varchar(MAX)","logicOperator":"AND"},{"columnName":"AppicationID","value":"${item?.APPLICATION_ID?.trim()}","operator":"=","dataType":"varchar(MAX)","logicOperator":"AND"},{"columnName":"CERTIFICATION_PID","value":"","operator":"=","dataType":"varchar(MAX)","logicOperator":"AND"},{"columnName":"ANNOUNCEMENT_ID","value":"${item?.ANNOUNCEMENT_ID?.trim()}","operator":"=","dataType":"varchar(MAX)","logicOperator":"AND"}]`,
      columns: "*",
      location: "JobApplicant-global",
      pageNumber: 1,
      pageSize: 999,
      sortData: "",
      additionalWhere: "",
      qID: 0,
    };
    try {
      const response = await advanceSearch(payload);
      const { results } = response;
      const tempHistory = results.map((notify) => {
        return {
          ...notify,
          id: notify.NotifiedOn,
          date: notify.NotifiedOn,
          message: notify?.NotificationText ?? "",
          response: notify?.ja_desc ?? "",
          status: notify?.ja_Status,
          statusCode: notify?.ja_statucode,
        };
      });
      setNotificationHistory(tempHistory);
      console.log(response?.results, "fetchNotification1221");
    } catch (error) {
      ShowError(error?.message ?? "Something went wrong");
    } finally {
      setAuditTrailLoader(false);
    }
  };

  const notifySingleApplicantsHandler = async (applicant) => {
    console.log(applicant, "itemdata1221");
    // return
    setAuditTrailLoader(true);
    const url = `${process.env.REACT_APP_API_DOTNET_URL}/GeneralAvaibility/SendNotificationBulk`;
    const payloadData = detailedData
      .filter(
        (item) => item.APPLICANT_SSN?.trim() === applicant.APPLICANT_SSN?.trim()
      )
      .map((notifyData) => {
        return {
          applicanT_SSN: notifyData.APPLICANT_SSN?.trim(),
          applicatioN_ID: notifyData.APPLICATION_ID?.trim(),
          generaL_AVAILIBILITY_ID: notifyData.GENERAL_AVAILIBILITY_ID,
          announcemenT_ID: notifyData.ANNOUNCEMENT_ID?.trim(),
          flag: true,
        };
      });
    try {
      const response = await post(url, {
        data: payloadData,
        text: message,
      });
      ShowSucess("Aplicants Notified");
      // setApplicantsNotifyModal(!applicantsNotifyModal);
      detailHandler();
      // setToggleApiCall(!toggleApiCall);
    } catch (error) {
      ShowError(error?.message ?? "Something Went Wrong");
    } finally {
      setAuditTrailLoader(false);
    }
  };

  const notifyApplicantsHandler = async () => {
    setNotifyLoader(true);
    const url = `${process.env.REACT_APP_API_DOTNET_URL}/GeneralAvaibility/SendNotificationBulk`;
    const payloadData = detailedData
      .filter((item) => item.status == null)
      .map((notifyData) => {
        return {
          applicanT_SSN: notifyData.APPLICANT_SSN?.trim(),
          applicatioN_ID: notifyData.APPLICATION_ID?.trim(),
          generaL_AVAILIBILITY_ID: notifyData.GENERAL_AVAILIBILITY_ID,
          announcemenT_ID: notifyData.ANNOUNCEMENT_ID?.trim(),
        };
      });
    try {
      const response = await post(url, {
        data: payloadData,
        text: message,
      });
      ShowSucess("Aplicants Notified");
      setApplicantsNotifyModal(!applicantsNotifyModal);
      detailHandler();
      // setToggleApiCall(!toggleApiCall);
    } catch (error) {
      ShowError(error?.message ?? "Something Went Wrong");
    } finally {
      setNotifyLoader(false);
    }
  };

  const handleapplicantsNotifyModal = () => {
    setApplicantsNotifyModal(!applicantsNotifyModal);
  };

  const leftBoxRef = useRef(null);

  const scrollDown = () => {
    if (leftBoxRef.current) {
      leftBoxRef.current.scrollBy({
        top: 100, // Adjust this value as needed
        behavior: "smooth",
      });
    }
  };

  const navigate = useNavigate();

  const addTenDays = (dateString) => {
    let date = new Date(dateString);
    date.setDate(date.getDate() + 10);
    let newDateString = date.toISOString();
    return newDateString;
  };

  const formatDateToMMDDYYYYWithTime = (date) => {
    if (date) {
      return new Date(date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        // second: "numeric",
        hour12: true,
      });
    }
    return "N/A";
  };

  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    };
    return new Date(dateString).toLocaleDateString("en-US", options);
  };

  console.log(notifyReached, "notifyReached1221");

  const sendMessageHandler = async (sendMessage, ParentCheck) => {
    // if (hasExpired) {
    //   ShowError(
    //     "This action is disabled because the 10-day period has expired."
    //   );
    //   toggle();
    //   return;
    // }
    setNotifyLoader(true);
    const url = `${process.env.REACT_APP_API_DOTNET_URL}/GeneralAvaibility/Notification`;
    let parentId = {};
    if (ParentCheck) {
      parentId["parentId"] = ParentCheck;
    }
    try {
      const response = await post(url, {
        generalAvailibilityId: messageModalData.GENERAL_AVAILIBILITY_ID?.trim(),
        sourceId: messageModalData.APPLICATION_ID?.trim(),
        applicantssn: messageModalData.APPLICANT_SSN?.trim(),
        announcementId: messageModalData?.ANNOUNCEMENT_ID?.trim(),
        text: sendMessage,
        positionTitle: messageModalData?.PositionTitle?.trim(),
        positionNo: messageModalData?.POSITION_NO?.trim(),
        // "parentId": 0
        ...parentId,

        // applicanT_SSN: messageModalData.APPLICANT_SSN?.trim(),
        // applicatioN_ID: messageModalData.APPLICATION_ID?.trim(),
        // generaL_AVAILIBILITY_ID:
        //   messageModalData.GENERAL_AVAILIBILITY_ID?.trim(),
        // announcemenT_ID: messageModalData.ANNOUNCEMENT_ID?.trim(),
        // text: sendMessage,

        // certificatioN_PID: messageModalData.CERTIFICATION_PID?.trim(),
      });
      ShowSucess("Aplicants Notified");
      //   setApplicantsNotifyModal(!applicantsNotifyModal);
      toggle();
      detailHandler();
      // setToggleApiCall(!toggleApiCall);
    } catch (error) {
      ShowError(error?.message ?? "Something Went Wrong");
    } finally {
      setNotifyLoader(false);
    }
  };

  return (
    <Container fluid={true}>
      {auditTrailLoader && loadingPanel()}
      <Row className="bg-primary rounded py-2 mb-3 sticky-top">
        <Col className="d-flex align-items-center gap-2">
          <Btn
            attrBtn={{
              color: "primary",
              onClick: () => {
                // openCloseSidebar();
                navigate(-1);
              },
              //   className: "custom-back-button",
              //   title: "Back to Menu",
              style: {
                fontSize: "18px",
                outline: "1px solid white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "4px 8px",
                paddingRight: "10px",
                // fontSize: '1rem',
                cursor: "pointer",
                marginRight: "6px",
              },
            }}
          >
            <Icon
              size="medium"
              style={{
                fontSize: "25px",
                marginRight: "5px",
                // cursor:"pointer",
              }}
              name="arrow-left"
              onClick={() => {
                navigate(-1);
              }}
            />
            Back
          </Btn>
          <FontAwesomeIcon icon={faCertificate} size="xl" />
          <Typography
            variant="h6"
            style={{ color: "white", display: "flex", alignItems: "center" }}
          >
            Announcement-General Availability
          </Typography>
        </Col>
        {/* <Col className="d-flex justify-content-end align-items-center">
          <div
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
            }}
          >
            <FontAwesomeIcon
              icon={faSearch}
              style={{
                position: "absolute",
                left: "22px",
                zIndex: 1,
                color: "blue",
                fontSize: "18px",
              }}
            />
            <TextField
              variant="outlined"
              placeholder="Announcement, Position No, Position Name ..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                borderRadius: "20px",
                marginLeft: "10px",
                backgroundColor: "white",
                paddingLeft: "40px", // to make space for the search icon
                width: "550px",
              }}
              InputProps={{
                style: { borderRadius: "20px" },
              }}
              size="small"
            />
          </div>
        </Col> */}
      </Row>
      <Box display="flex" height="70vh">
        <Box
          flex={2}
          overflow="auto"
          p={2}
          position="relative"
          ref={leftBoxRef}
          style={{
            scrollbarWidth: "none", // For Firefox
            msOverflowStyle: "none", // For Internet Explorer and Edge
          }}
        >
          <Box style={{ marginTop: "0px", marginLeft: "0px" }}>
            <Box style={{ borderLeft: "0px solid #000", paddingLeft: "0px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div style={{ width: "560px", maxWidth: "50%" }}>
                  <TextField
                    label="Name, Application Number ..."
                    variant="outlined"
                    fullWidth
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ marginBottom: "0px" }}
                    size="small"
                  />
                </div>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    let text =
                      notifyReached == 2
                        ? `Please let us know if you are available for the Position: ${data.POSITION_NO
                        }-${data.PositionTitle}, Announcement: ${data.Announcement_id
                        }. If we do not hear from you by ${formatDateToMMDDYYYYWithTime(
                          addTenDays(data.createdOn)
                        )}, we will assume you are no longer interested and proceed with other candidates.`
                        : `This is follow-up message regarding your availability for Position: ${data.POSITION_NO}-${data.PositionTitle},Announcement: ${data.Announcement_id}, please respond.`;
                    setMessage(text);
                    handleapplicantsNotifyModal();
                  }}
                  disabled={notifyReached == 3}
                >
                  Notify Pending Response Applicants
                </Button>
              </div>
              {loadingDetails ? (
                <CircularProgress />
              ) : (
                filteredItems.map((item, index) => (
                  <Accordion key={index} defaultExpanded>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      style={{ position: "relative" }}
                    >
                      <Typography
                        variant="subtitle1"
                        style={{ fontWeight: "bold" }}
                      >
                        {item.APPLICANT_NAME}
                      </Typography>
                      <Chip
                        icon={getStatusIcon(item.status)}
                        label={getStatus(item.status)}
                        style={{
                          marginLeft: "8px",
                          backgroundColor: getBackgroundForStatus(item.status),
                        }}
                        size="small"
                      />
                      {item.Backup && (
                        <Chip
                          // icon={getStatusIcon(item.status)}
                          label={"Backup"}
                          style={{
                            marginLeft: "8px",
                            //   backgroundColor: getBackgroundForStatus(item.status),
                          }}
                          size="small"
                        />
                      )}
                      <Button
                        variant="outlined"
                        size="small"
                        style={{ marginLeft: "8px", marginBottom: "10px" }}
                        onClick={() => {
                          navigate("/applicant-audit-trail", {
                            state: { detailData: JSON.stringify(item) },
                          });
                        }}
                      >
                        Audit Trail
                      </Button>
                      {/* <FontAwesomeIcon
                        color="green"
                        icon={faMessageCaptions}
                        size="2x"
                        onClick={() => {
                          // if (item?.Contacted) {
                          toggle();
                          setNotificationHistory(
                            item?.notificationHistory ?? []
                          );
                          // setMessageModalData(item);
                          getAuditTrail(item);
                          // }
                        }}
                        style={{ cursor: "pointer", marginLeft:"10px" }}
                      /> */}
                      {/* <Typography variant="subtitle2" style={{ marginLeft: "auto" }}>{getStatusIcon(item.status)} {getStatus(item.status)}</Typography> */}
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography
                        variant="body2"
                        style={{ marginTop: "-29px" }}
                      >
                        Last Notified on:{" "}
                        {new Date(item.Notifiedon).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}
                      </Typography>
                      <div
                        style={{
                          display: "flex",
                          marginTop: "10px",
                          gap: "8px",
                        }}
                      >
                        {/* <Typography variant="body2">SSN: {item.APPLICANT_SSN}</Typography> */}
                        <Typography variant="body2">
                          Application ID: {item.APPLICATION_ID}
                        </Typography>
                        <Typography variant="body2">
                          Evaluation Rating: {item.EVALUATION_RATING}
                        </Typography>
                        <Typography variant="body2">
                          Number of Notifications:{" "}
                          {item?.no_of_notification || 3}
                        </Typography>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          marginTop: "4px",
                          marginBottom: "4px",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            // flexDirection:"column",
                            gap: "8px",
                            position: "absolute",
                            top: "10px",
                            right: "29px",
                            // alignItems: "center",
                          }}
                        >
                          <Tooltip>
                            <FontAwesomeIcon
                              icon={faSync}
                              size="2x"
                              title="Notify Again"
                              style={{
                                padding: "5px",
                                cursor: "pointer",
                                // cursor: hasExpired ? "not-allowed" : "pointer",
                                // color: hasExpired ? "grey" : "inherit",
                              }}
                              onClick={() => {
                                notifySingleApplicantsHandler(item);
                              }}
                            />
                          </Tooltip>
                          <Tooltip>
                            <FontAwesomeIcon
                              icon={faMessageCaptions}
                              size="2x"
                              color="green"
                              title="Notification History"
                              style={{
                                padding: "5px",
                                cursor: "pointer",
                                // cursor: hasExpired ? "not-allowed" : "pointer",
                                // color: hasExpired ? "grey" : "green",
                              }}
                              onClick={() => {
                                toggle();
                                setNotificationHistory(
                                  item?.notificationHistory ?? []
                                );
                                setMessageModalData(item);
                                getAuditTrail(item);
                              }}
                            />
                          </Tooltip>
                          <ul
                            style={{
                              // border: "1px solid #ccc",
                              padding: "5px",
                              borderRadius: "5px",
                              listStyle: "none",
                              margin: 0,
                            }}
                          >
                            <li
                              style={{
                                display: "block",
                                marginRight: "10px",
                                border: "1px solid lightblue",
                                padding: "4px",
                              }}
                            >
                              <Typography variant="body2">
                                Notification Dates
                              </Typography>
                            </li>
                            {item?.notification_dates
                              //   ||
                              //   "2024-06-27T22:56:15.753,2024-06-25T22:56:15.753,2024-06-22T22:56:15.753"
                              ?.split(",")
                              ?.reverse()
                              ?.map((date, idx) => {
                                const getOrdinalSuffix = (n) => {
                                  const s = ["th", "st", "nd", "rd"],
                                    v = n % 100;
                                  return n + (s[(v - 20) % 10] || s[v] || s[0]);
                                };
                                const formattedDate = new Date(
                                  date
                                ).toLocaleDateString("en-US", {
                                  year: "numeric",
                                  month: "long",
                                  day: "numeric",
                                });
                                return (
                                  <li
                                    key={idx}
                                    style={{
                                      display: "block",
                                      marginRight: "10px",
                                      border: "1px solid lightblue",
                                      padding: "4px",
                                    }}
                                  >
                                    <span style={{ width: "40px" }}>
                                      {getOrdinalSuffix(idx + 1)}:{" "}
                                    </span>
                                    {getStatusIconWithColor(
                                      item.status,
                                      item?.notification_dates,
                                      idx + 1
                                    )}
                                    {formattedDate}
                                  </li>
                                );
                              })
                              ?.slice(-3)}
                          </ul>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            gap: "8px",
                          }}
                        >
                          {/* <Typography variant="body2">SSN: {item.APPLICANT_SSN}</Typography> */}
                          {/* <Typography variant="body2">
                            Applicant ID: {item?.APPLICANT_ID ?? "N/A"}
                          </Typography> */}
                          <Typography variant="body2">
                            Eligibility List: {item?.ELIGIBILITY_ID?.trim()}
                          </Typography>
                        </div>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                ))
              )}
            </Box>
          </Box>
          {filteredItems.length > 3 && (
            <Box
              onClick={scrollDown}
              sx={{
                position: "fixed",
                bottom: 65,
                left: "45%",
                transform: "translateX(-50%)",
                cursor: "pointer",
                bgcolor: "lightblue",
                p: 1,
                borderRadius: "50%", // Make it circular
                width: "40px", // Adjust size as needed
                height: "40px", // Adjust size as needed
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.4)",
              }}
            >
              <FontAwesomeIcon icon={faArrowDown} />
            </Box>
          )}
        </Box>
        <Box flex={1} p={2} position="sticky" top={0}>
          <div>
            <Typography variant="h6" style={{ marginRight: "10px" }}>
              {data.id}
            </Typography>
            <div style={{ display: "flex", alignItems: "center", marginTop: "5px" }}>
              <Typography
                variant="body2"
                style={{ marginRight: "10px", marginTop: "-10px" }}
              >
                Announcement Id: {data.Announcement_id}
              </Typography>
              <Chip
                label={"Open"}
                style={{
                  backgroundColor: "lightgreen",
                  marginLeft: "5px",
                  marginTop: "-10px",
                }}
                size="small"
              />
            </div>
            <Typography
              variant="body2"
              style={{ marginRight: "10px", marginTop: "-5px" }}
            >
              No of Openings: {data.Vacancy}
            </Typography>
            <div style={{ display: 'grid', placeItems: 'center' }}>
              <HighchartsReact highcharts={Highcharts} options={options} />
            </div>
            <Box mt={0} sx={{ padding: "0 8px" }}>
              <Typography variant="body1">
                <FontAwesomeIcon
                  icon={faUsers}
                  size="small"
                  color="lightblue"
                  fontSize={"12px"}
                />{" "}
                Eligible Applicants: {data.totalEligible}
                <ProgressBar
                  value={data.totalNotified}
                  max={data.totalEligible}
                />
              </Typography>
              <Box
                display="flex"
                justifyContent="space-between"
                width="100%"
                mb={1}
              >
                <Box display="flex" gap={1} alignItems="center">
                  <Box
                    width={10}
                    height={10}
                    bgcolor="#1a90ff"
                    borderRadius="50%"
                    mb={0}
                  />
                  <Typography variant="body2">
                    Notified ({data.totalNotified})
                  </Typography>
                </Box>
                <Box display="flex" gap={1} alignItems="center">
                  <Box
                    width={10}
                    height={10}
                    bgcolor="#ffcccb"
                    borderRadius="50%"
                    mb={0}
                  />
                  <Typography variant="body2">
                    Remaining ({data.totalEligible - data.totalNotified})
                  </Typography>
                </Box>
              </Box>
            </Box>
          </div>
        </Box>
      </Box>
      <Modal
        isOpen={applicantsNotifyModal}
        toggle={handleapplicantsNotifyModal}
      >
        <ModalHeader toggle={handleapplicantsNotifyModal}>
          Enter your message
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="message">Message</Label>
              <Input
                type="textarea"
                name="message"
                id="message"
                rows={4}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleapplicantsNotifyModal}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={notifyApplicantsHandler}
            disabled={notifyLoader}
          >
            {notifyLoader ? <Spinner size="sm" /> : "Submit"}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Notification History Modal */}
      <Modal isOpen={modal} toggle={toggle} size="xl" centered>
        <ModalHeader toggle={toggle}>
          Notifications
          <Button
            aria-label="Cancel"
            onClick={() => {
              setToggleNotificationDate(true);
              toggle();
            }}
            style={{
              position: "absolute",
              right: "10px",
              top: "10px",
              background: "none",
              border: "none",
              fontSize: "1.5rem",
              cursor: "pointer",
            }}
          >
            <i className="fas fa-times"></i>
          </Button>
        </ModalHeader>
        <ModalBody style={{ overflowY: "auto", overflowX: "hidden" }}>
          {/* <Input
            type="textarea"
            //   name="message"
            id="messageSend"
            rows={4}
            value={sendMessage}
            onChange={(e) => setSendMessage(e.target.value)}
          />
          <div style={{ display: "flex", flexDirection: "row-reverse" }}>
            <Button color="primary" onClick={sendMessageHandler}>
              {notifyLoader ? <Spinner size="sm" /> : "Submit"}
            </Button>
          </div>
          <strong>History</strong>
          <Table bordered hover>
            <thead>
              <tr>
                <th
                  style={{ whiteSpace: "nowrap", cursor: "pointer" }}
                  onClick={() =>
                    setToggleNotificationDate(!toggleNotificationDate)
                  }
                >
                  Notification Date
                  <i className="fa-sharp fa-regular fa-arrow-up-arrow-down"></i>
                </th>
                <th style={{ whiteSpace: "nowrap" }}>Sent Message</th>
                <th style={{ whiteSpace: "nowrap" }}>Status</th>
                <th style={{ whiteSpace: "nowrap" }}>Response Message</th>
                <th style={{ whiteSpace: "nowrap" }}>Activity</th>
              </tr>
            </thead>
            <tbody>
              {sortedData(toggleNotificationDate).map((row) => (
                <tr key={row.id}>
                  <td>{formatDate?.(row?.date) ?? ""}</td>
                  <td
                    style={{ whiteSpace: "pre-wrap" }}
                    dangerouslySetInnerHTML={{ __html: row?.message ?? "" }}
                  />
                  <td>
                    {row?.ja_statucode ? (
                      <Chip
                        sx={{
                          backgroundColor: getStatusAssignedColor(
                            row?.ja_statucode
                          ),
                          color: "white",
                        }}
                        label={
                          row?.ja_statucode
                            ? `${row?.ja_statucode} - ${showStatusAssigned(
                                row?.ja_statucode
                              )}`
                            : "Pending"
                        }
                        size="small"
                      />
                    ) : (
                      <Chip
                        icon={getStatusIcon(row.ja_Status)}
                        label={getStatus(row.ja_Status)}
                        style={{
                          marginLeft: "8px",
                          backgroundColor: getBackgroundForStatus(
                            row.ja_Status
                          ),
                        }}
                        size="small"
                      />
                    )}
                  </td>
                  <td>{row?.response ?? ""}</td>
                  <td>{row?.Actitvity ?? "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </Table> */}
          <ChatUI
            messages={notificationHistory}
            sendMessageHandler={sendMessageHandler}
          />
        </ModalBody>
        {/* <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Close
          </Button>
        </ModalFooter> */}
      </Modal>
    </Container>
  );
};

export default ApplicantsDetail;
